// 冲单激励
import http from '@core/api/http'
import { Res } from '@core/api/type'
import { getInspireResp, getSortResp } from '@/model/award/award'

//查询激励和票数
export const getInspire = (): Res<getInspireResp> => {
  return http.request({
    url: '/app/sendInspire/querySendInspire',
    method: 'post',
    loadingShow: '0'
  })
}

//物料详情
export const getSort = (): Res<getSortResp> => {
  return http.request({
    url: '/app/sendInspire/querySendInspireSort',
    method: 'post',
    loadingShow: '0'
  })
}
